<template>
  <component :is="userData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
        variant="danger"
        :show="userData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
            class="alert-link"
            :to="{ name: 'pegawai'}"
        >
          List Pegawai
        </b-link>
        for other users.
      </div>
    </b-alert>

    <edit-account
        v-if="userData"
        :user-data="userData"
        :pengawas-options="pengawasOptions"
        :bidang-options="bidangOptions"
        :pengawas="userData.pengawas"
        class="mt-2 pt-75"
    />
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import {ref, onUnmounted} from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import pegawaiStoreModule from '../PegawaiStoreModule'
import EditAccount from './EditAccount.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    EditAccount,
  },
  data() {
    return {
      pengawasOptions: [],
      bidangOptions: [],
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
  },
  setup() {
    const userData = ref(null)

    const APP_STORE_MODULE_NAME = 'app-pegawai'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, pegawaiStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-pegawai/fetch', router.currentRoute.params.id)
        .then(response => {
          userData.value = response.data.data
        })
        .catch(error => {
          if (error.response.status === 404) {
            userData.value = undefined
          }
        })

    return {
      userData,
    }
  },
  methods: {
    pengawasOptionsGetters() {
      store
          .dispatch('app-pegawai/pengawas', {
            perPage: 1000,
          })
          .then(response => {
            const data = []
            if (this.user.type === 'Pengawas') {
              for (let key in response.data.data.data) {
                if (this.user.id === response.data.data.data[key].id) {
                  data.push({
                    'label': response.data.data.data[key].nama,
                    'value': response.data.data.data[key],
                  });
                }
              }
            } else {
              for (let key in response.data.data.data) {
                data.push({
                  'label': response.data.data.data[key].nama,
                  'value': response.data.data.data[key],
                });
              }
            }
            this.pengawasOptions = data
          })
          .catch((error) => {
            console.log(error)
          })
    },
    bidangOptionsGetters() {
      store
          .dispatch('app-pegawai/bidang', {
            perPage: 1000,
          })
          .then(response => {
            const data = []
            for (let key in response.data.data.data) {
              data.push({
                'label': response.data.data.data[key].nama,
                'value': response.data.data.data[key].id,
              });
            }
            this.bidangOptions = data
          })
          .catch((error) => {
            console.log(error)
          })
    },
  },
  async created() {
    this.pengawasOptionsGetters()
    this.bidangOptionsGetters()
  }
}
</script>

<style>

</style>
